<template>
  <div class="dropdown-input-container mb-3">
    <label>
      <question-display :question="question" customClass="header-dropdown"></question-display>
    </label>

    <multiselect
      v-model="inputValue"
      :options="dropdownOptions"
      :searchable="true"
      :close-on-select="true"
      :clear-on-select="false"
      label="name"
      track-by="value"
      :filter-method="customFilter"
      :custom-label="customLabel"
      @update:modelValue="updateInput"
    />



    <small v-if="showValidation && question.required && !inputValue" class="text-danger">
      This field is required.
    </small>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import dropdownValues from "@/assets/data/dropdown-values/dropdown.json";
import surveyService from "@/services/surveyService";
import QuestionDisplay from "../utils/QuestionDisplay.vue";

export default {
  components: {
    QuestionDisplay,
    Multiselect,
  },
  props: {
    question: Object,
    required: Boolean,
    showValidation: Boolean,
  },
  data() {
    return {
      dropdownOptions: [],
      inputValue: this.getSelectedOption(surveyService.getAnswer(this.question.id)),
    };
  },
  methods: {
    updateInput() {
      surveyService.setAnswer(this.question.id, this.inputValue.value);
      this.$emit("input", this.inputValue);
    },
    getSelectedOption(value) {
      return this.dropdownOptions?.find(option => option.value === value) || null;
    },
    loadDropdownValues() {
      if (this.question["selection-list"]) {
        const key = this.question["selection-list"].value;
        this.dropdownOptions = dropdownValues[key] || [];

        if(this.question['default-value']){
          const defaultConfig = this.question['default-value'];
          const conditionAnswer = surveyService.getAnswer(defaultConfig['question_id']);
          const conditionAnswerStr = String(conditionAnswer || '');
          // If the condition matches, use the 'default' value; otherwise use the answer directly
          let defaultVal;
          if (defaultConfig['value'] && defaultConfig['default']) {
            // Conditional default: if answer matches 'value', use 'default'
            defaultVal = conditionAnswerStr === String(defaultConfig['value'])
              ? defaultConfig['default']
              : conditionAnswer;
          } else {
            defaultVal = conditionAnswer;
          }
          if (defaultVal) {
            surveyService.setAnswer(this.question.id, defaultVal);
          }
        }
      } else {
        this.dropdownOptions = this.question.options || [];
      }
      // Ensure inputValue is correctly set after loading options
      this.inputValue = this.getSelectedOption(surveyService.getAnswer(this.question.id));
    },
    customLabel(option) {
      if(this.question.id === '1b'){
        return `${option.name} (${option.value})`;
      }
      return `${option.name}`;
    },
    customFilter(option, search) {
      const searchText = search.toLowerCase();
      console.log(option)
      return (
        option.name?.toLowerCase().includes(searchText) ||
        option.value?.toLowerCase().includes(searchText)
      );
    }


  },
  watch: {
    question(newQuestion) {
      this.inputValue = surveyService.getAnswer(newQuestion.id) || "";
      this.loadDropdownValues();
    },
  },
  mounted() {
    this.loadDropdownValues();
  },
};
</script>
